<template>
	<section v-if="errorType === '401'">
		<h1>Kein Zugriff</h1>
		<p>Sie sind nicht berechtigt diese Seite einzusehen.</p>
	</section>
	<section v-else-if="redirectedFrom === 'download'">
		<h1>Datei nicht gefunden</h1>
		<p>Die angeforderte Datei konnte nicht gefunden werden.</p>
	</section>
	<section v-else>
		<h1>Seite nicht gefunden</h1>
		<p>Die angeforderte Seite konnte nicht gefunden werden.</p>
	</section>
</template>

<script>
export default {
	name: 'Fehler',
	data() {
		return {
			redirectedFrom: '',
		};
	},
	props: {
		errorType: {
			type: String,
			required: false,
		},
	},
	mounted() {
		if (this.$route.query.redirectedFrom) {
			this.redirectedFrom = this.$route.query.redirectedFrom;
		}
	},
};
</script>
